export default __webpack_public_path__ + "static/media/Amdocs Customer Engagement eBook.e468ebf4.pdf";